package com.trevorwiebe.timesheet.core.domain.dto

import com.trevorwiebe.timesheet.core.domain.Util
import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.UserRole
import kotlinx.serialization.Serializable

@Serializable
data class DatabaseUserDto(
    val role: String,
    val adminAccess: Boolean,
    val email: String,
    val fullTime: Boolean,
    val hireDate: String,
    val name: String,
    val nickname: String,
    val organizationId: String,
    val ptoBalance: Int,
    val holidayTime: Boolean,
    val payEntryId: String,
    val deleted: Boolean,
    val ownerOperatorId: String? = null
)

fun DatabaseUserDto.toDatabaseUserModel(id: String): DatabaseUserModel {
    return DatabaseUserModel(
        id = id,
        role = UserRole.valueOf(role),
        email = this.email,
        fullTime = this.fullTime,
        hireDate = Util.convertStringToLocalDate(this.hireDate),
        name = this.name,
        nickname = this.nickname,
        organizationId = this.organizationId,
        ptoBalance = this.ptoBalance,
        holidayTime = this.holidayTime,
        payEntryId = this.payEntryId,
        deleted = this.deleted,
        ownerOperatorId = this.ownerOperatorId
    )
}

fun DatabaseUserModel.toDatabaseUserDto(): DatabaseUserDto {
    return DatabaseUserDto(
        role = this.role.name,
        adminAccess = this.role == UserRole.ADMIN,
        email = this.email,
        fullTime = this.fullTime,
        hireDate = this.hireDate.toString(),
        name = this.name,
        nickname = this.nickname,
        organizationId = this.organizationId,
        ptoBalance = this.ptoBalance,
        holidayTime = this.holidayTime,
        payEntryId = this.payEntryId,
        deleted = this.deleted,
        ownerOperatorId = this.ownerOperatorId
    )
}
